import { useQuery } from "react-query"
import { get_job_seeker_educations } from "../../../services/approvals";


const useJobSeekerEducations = (id) => {
    return useQuery('get_job_seeker_educations', ()=> get_job_seeker_educations(id))
}

export default useJobSeekerEducations;